"use strict";

module.exports = [
  "$scope",
  "$rootScope",
  "$location",
  "$interval",
  "PlantSvc",
  "OrderSvc",
  "ModalSvc",
  "PermissionSvc",
  "UserProfileSvc",
  "OrderRequestSvc",
  function(
    $scope,
    $rootScope,
    $location,
    $interval,
    PlantSvc,
    OrderSvc,
    ModalSvc,
    PermissionSvc,
    UserProfileSvc,
    OrderRequestSvc
  ) {
    // ------------------
    // Internal
    // ------------------
    var DEFAULT_PLANT_TAB = "calendar";
    var DEFAULT_CONFIG_TAB = "general";

    // TODO: Move to a directive
    function loadTentativeOrders() {
      if ($scope.permissions.view_orders) {
        OrderSvc.list_tentative($scope.plant).success(function(data) {
          $scope.tentativeOrders = data;
        });
      }
    }

    function getNewRequestsCount() {
      if ($scope.role != "Customer" && $scope.permissions.view_order_request) {
        OrderRequestSvc.new_requests_count($rootScope.plant).success(function(
          new_requests_count
        ) {
          $scope.new_requests_count = new_requests_count;
        });
      }
    }

    function navigate(plantTab, configTab) {
      $location.search({ tab: plantTab, details: configTab });

      // TODO: Find a better place to update requests count
      getNewRequestsCount();
    }

    // ------------------
    // scope functions
    // ------------------
    $scope.setPlantTab = function(tab) {
      if (tab === DEFAULT_PLANT_TAB) tab = undefined;
      navigate(tab, $location.search().details);
    };

    $scope.setConfigTab = function(configTab) {
      if (configTab === DEFAULT_CONFIG_TAB) configTab = undefined;
      navigate("plant_configuration", configTab);
    };

    $scope.highlightOrder = function(order) {
      $scope.$broadcast("highlightOrder", order);
    };

    $scope.exportOrderDataAsCSV = function() {
      var pathname = window.location.pathname;
      var origin = window.location.origin;
      window.location.href = origin + '/api/plant/' + pathname.replace(/\D/g,'') + '/export/orders?format=csv';
    }

    $scope.openOrderDialog = function($event, config) {
      $event.stopPropagation();
      ModalSvc.orderEditModal.open(config);
      introJs().exit();
    };

    $scope.showTentativeOrders = function() {
      $scope.numberOfTentativeOrdersToShow = null;
    };

    $scope.showAllTentativeDates = function(tentativeOrder) {
      tentativeOrder.showAllTentativeDatesList = true;
    };

    $scope.toggleDetails = function() {
      $scope.plant_settings.show_details = !$scope.plant_settings.show_details;

      var settings = {
        show_details: $scope.plant_settings.show_details
      };

      UserProfileSvc.updatePlantSettings(
        $rootScope.plant,
        $rootScope.user_id,
        settings
      ).then(function(result) {
        $rootScope.$emit("user-profile-plant-settings-updated", result.data);
      });
    };

    $scope.openProductionCalendarEntryDialog = function($event, config) {
      $event.stopPropagation();
      ModalSvc.productionModeCalendarEntryEditModal.open(config);
    };

    // ------------------
    // Helper functions
    // ------------------
    function sendRefreshSignal() {
      $rootScope.$broadcast("refresh-signal");
    }

    // ------------------
    // Events
    // ------------------
    $scope.$on("$locationChangeSuccess", function(e, url, oldUrl) {
      $scope.configTab = $location.search().details || DEFAULT_CONFIG_TAB;
      $scope.plantTab = $location.search().tab || DEFAULT_PLANT_TAB;
    });

    $scope.$on("refresh-signal", function() {
      loadTentativeOrders();
      getNewRequestsCount();
    });

    // clear auto refresh timer when controller is destroyed
    $scope.$on("$destroy", function() {
      if (autoRefreshTimer) {
        $interval.cancel(autoRefreshTimer);
      }
    });

    // ------------------
    // Watches
    // ------------------
    $scope.$watchCollection(
      function() {
        if (angular.isDefined($rootScope.user_profile)) {
          return $rootScope.user_profile.plant_settings;
        }
      },
      function(newVal, oldVal) {
        if (angular.isDefined(newVal)) {
          var plant_settings = Array.findObject(
            newVal,
            "plant",
            parseInt($rootScope.plant)
          );

          // if plant settings already exist
          if (plant_settings != -1) {
            $scope.plant_settings = plant_settings;
          } else {
            // default settings TODO: MOVE TO SERVER
            var settings = {};
            UserProfileSvc.updatePlantSettings(
              $rootScope.plant,
              $rootScope.user_id,
              settings
            ).then(function(result) {
              $rootScope.$emit(
                "user-profile-plant-settings-updated",
                result.data
              );
            });
          }
        }
      }
    );

    // ------------------
    // Fetch Data
    // ------------------
    PlantSvc.list().success(function(data) {
      $scope.plants = data;
      $scope.plantObj = Array.findObject(data, "id", parseInt($scope.plant));
    });

    PermissionSvc.getPlantPermissions($scope.plant).then(function(
      permissionsObject
    ) {
      $scope.permissions = permissionsObject.permissions;
      $scope.permissionsObject = permissionsObject;
      $scope.role = permissionsObject.role;

      loadTentativeOrders();
      getNewRequestsCount();
      
      let urlOrderId = $location.search().order;
      if (urlOrderId) {
        console.log('opening order id ', urlOrderId);
        ModalSvc.orderEditModal.open({order_id: urlOrderId});
      }
    });

    // ------------------
    // Initialization
    // ------------------
    $scope.configurationOpen = undefined;
    $scope.configTab = "";
    $scope.plantTab = "";
    $scope.plantObj = {};
    $scope.tentativeOrders = [];
    $scope.numberOfTentativeOrdersToShow = 6;

    // set auto refresh timer to 10min
    var autoRefreshTimer = $interval(sendRefreshSignal, 1000 * 60 * 10);
  }
];
